import { css } from "@vitality-ds/system";
export default css({
  position: "fixed",
  right: 0,
  top: 0,
  zIndex: "$toast",
  pointerEvents: "all"
});